/*
 * File: /src/store/modules/knowledgeCategories.js
 * Author: AdBase, Inc.
 * Copyright (c) 2026 AdBase, Inc.
 *
 * Holds the company categories the same way the knowledge types are held, the
 * API is only called the first time something asks for them.
 */

import KnowledgeCategoryService from 'src/services/knowledgeCategoryService';

const state = {
  knowledgeCategories: undefined,
};

const getters = {
  getKnowledgeCategories: (state) => state.knowledgeCategories,
  getKnowledgeCategoryById: (state) => (id) => {
    if (!state.knowledgeCategories) {
      return undefined;
    }
    return state.knowledgeCategories.find((category) => category.id == id);
  },
};

const actions = {
  async fetchKnowledgeCategories({ commit, state }) {
    // Only load the data once
    if (state.knowledgeCategories == undefined) {
      return KnowledgeCategoryService.fetchKnowledgeCategories().then((r) => {
        commit(
          'setKnowledgeCategories',
          Array.isArray(r.data) ? r.data : []
        );
      });
    }
  },
  // Keep the loaded list current after a create or an edit rather than
  // making every view reload the whole set
  upsertKnowledgeCategory({ commit }, knowledgeCategory) {
    if (knowledgeCategory && knowledgeCategory.id) {
      commit('upsertKnowledgeCategory', knowledgeCategory);
    }
  },
  removeKnowledgeCategory({ commit }, id) {
    commit('removeKnowledgeCategory', id);
  },
  unloadKnowledgeCategories({ commit }) {
    commit('setKnowledgeCategories', undefined);
  },
};

const byName = (first, second) =>
  String(first.name || '').localeCompare(String(second.name || ''));

const mutations = {
  setKnowledgeCategories(state, knowledgeCategories) {
    state.knowledgeCategories = knowledgeCategories;
  },
  upsertKnowledgeCategory(state, knowledgeCategory) {
    // Nothing is loaded yet, the next fetch will pick this one up
    if (state.knowledgeCategories == undefined) {
      return;
    }
    const categories = state.knowledgeCategories.filter(
      (category) => category.id != knowledgeCategory.id
    );
    categories.push(knowledgeCategory);
    state.knowledgeCategories = categories.sort(byName);
  },
  removeKnowledgeCategory(state, id) {
    if (state.knowledgeCategories == undefined) {
      return;
    }
    state.knowledgeCategories = state.knowledgeCategories.filter(
      (category) => category.id != id
    );
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
